import(/* webpackMode: "eager" */ "/nantan-expo/src/app/page.tsx");
